<template>
  <div class="w-100 d-inline-flex">
    <multiselect class="pr-2" v-if="!addNewPostalCode" :disabled="this.disabled" v-model="valueSelected" :options="postalCodes" track-by="uuid" label="code"
        :multiple="false" :allowEmpty="false" placeholder="Código Postal" selectedLabel="" selectLabel="" deselectLabel=""
        @select="notifyChange"></multiselect>
    <b-form-input class="w-100 pl-2" v-if="addNewPostalCode"
      id="postalCode"
      type="number"
      placeholder="Código Postal"
      v-model="postalCode" required></b-form-input>
      <button
        @click="addNewPostalCode = !addNewPostalCode"
        v-if="!addNewPostalCode"
        class="btn btn-lg d-inline-flex">
        <i class="fa fa-plus"></i>
      </button>
      <button
        :disabled="!postalCode"
        @click.self.prevent="storePostalCode"
        v-if="addNewPostalCode"
        class="btn btn-brand btn-primary btn-sm ml-3">
        Guardar
      </button>
    </div>
</template>
<script>

import Multiselect from "vue-multiselect";
import { getPostalCodes, createPostalCode } from "../../api/location-api";

export default {
    name: "NewLocationPostalCodeSelector",
    components: {
        Multiselect,
    },

    props: {
        postalCodeSelected: Object,
        townSelected: Object,
        initialPostalCode: Number,
        disabled: Boolean,
        onSelected: Function,
        fieldClearArray: Array,
        onFieldClear: Function,
    },
    data: function () {
        return {
            postalCodes: [],
            valueSelected: null,
            addNewPostalCode: false,
            postalCode: null
        };
    },

    methods: {
        notifyChange: function (value) {
            this.onSelected(value);
        },

        async getPostalCodeList(value) {
            getPostalCodes(value).then(postalCodes => {
                this.postalCodes = postalCodes;

                if (this.postalCodeSelected !== null) {
                    let findedPostalCode = this.postalCodes.find(postalCode => postalCode.uuid === this.postalCodeSelected.uuid);
                    this.valueSelected = findedPostalCode;
                } else if (this.initialPostalCode !== null && this.initialPostalCode !== undefined) {

                    let checkPostalCode = this.initialPostalCode.toString();
                    while (checkPostalCode.length < 5) {
                        checkPostalCode = "0" + checkPostalCode;
                    }

                    let findedPostalCode= this.postalCodes.find(postalCode => postalCode.code === checkPostalCode);
                    this.valueSelected = findedPostalCode;
                    this.onSelected(findedPostalCode);
                }
            })
        },

        async storePostalCode() {
          if (this.postalCode !== null) {
            this.$_loadingMixin_showLoading();
            await createPostalCode(
              this.townSelected.uuid,
              this.postalCode
            )
              .then((response) => {
                this.getPostalCodeList(this.townSelected.uuid);
                this.postalCodeSelected = response;
                this.addNewPostalCode = false;
                this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
              })
              .catch(() => {
                this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
              });
            this.$_loadingMixin_hideLoading();
          }
        }


    },
    watch: {
        townSelected: async function (value) {
            if(value !== null && value !== undefined) {
                await this.getPostalCodeList(value.uuid);
            }
        },

        fieldClearArray: function (value) {

            if (value.includes('postalCode')) {
                this.valueSelected = null;
                this.onSelected(null);
            }
        }

    }
}

</script>
